import type { CSSProperties, ReactNode } from 'react';

interface EyebrowProps {
  children: ReactNode;
  style?: CSSProperties;
  className?: string;
}

/**
 * Phase 25 — small uppercase ink-3 caption.
 *
 * 11px / 500 / 0.10em letter-spacing. Lives above values, section
 * headings, and key cells throughout the ledger aesthetic.
 */
export default function Eyebrow({ children, style, className = '' }: EyebrowProps) {
  return (
    <div
      className={`tco-eyebrow ${className}`.trim()}
      style={style}
    >
      {children}
    </div>
  );
}
